var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.756 28H43.2926L35.4686 51.182C35.304 51.6707 34.846 51.9993 34.33 51.9993H28.4646C27.802 51.9993 27.2646 51.462 27.2646 50.7993C27.2646 50.6687 27.286 50.5393 27.3273 50.4153L34.6173 28.818C34.782 28.3293 35.24 28 35.756 28Z",
    fill: "url(#paint0_linear_163_64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.708 43.5493H34.7566C34.4513 43.5487 34.2033 43.7967 34.2026 44.102C34.2026 44.256 34.266 44.4027 34.3786 44.5073L42.0586 51.6753C42.282 51.884 42.5766 52 42.8826 52H49.65L46.708 43.5493Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.756 28C35.234 27.998 34.772 28.336 34.6147 28.8333L27.3367 50.3967C27.1133 51.0193 27.4373 51.706 28.06 51.9293C28.1907 51.976 28.3287 52 28.468 52H34.4853C34.9413 51.9187 35.3187 51.598 35.4727 51.1607L36.924 46.8833L42.108 51.7187C42.3253 51.8987 42.598 51.998 42.88 52H49.6227L46.6653 43.5493L38.0447 43.5513L43.32 28H35.756Z",
    fill: "url(#paint1_linear_163_64)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3827 28.8167C45.218 28.3287 44.7607 28 44.2453 28H35.8453C36.36 28 36.818 28.3287 36.982 28.816L44.272 50.4153C44.484 51.0433 44.1467 51.724 43.5187 51.936C43.3953 51.9787 43.266 52 43.1353 52H51.5353C52.198 52 52.7353 51.4627 52.7353 50.7993C52.7353 50.6687 52.714 50.5393 52.672 50.416L45.3827 28.8167Z",
    fill: "url(#paint2_linear_163_64)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_64",
    x1: 38.5031,
    y1: 29.7788,
    x2: 30.676,
    y2: 52.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_163_64",
    x1: 40.9479,
    y1: 40.5538,
    x2: 39.1375,
    y2: 41.1663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_163_64",
    x1: 40.0083,
    y1: 29.083,
    x2: 48.6,
    y2: 51.9736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.204d84e29af95dcc162b648adf66223e.svg";
export { ForwardRef as ReactComponent };